exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-status-wrapper[data-v-5b871dd0] {\n  margin-top: 0px;\n  text-align: center;\n}\n.product-status-wrapper .available[data-v-5b871dd0] {\n  color: #04B200;\n  margin-top: 0;\n}\n.product-status-wrapper .unavailable[data-v-5b871dd0] {\n  margin-top: 0;\n}\n.status[data-v-5b871dd0] {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 3px;\n  font-size: 14px;\n}\n.status .material-icons[data-v-5b871dd0] {\n  font-size: 1em;\n  position: relative;\n  top: 2px;\n}\n", ""]);

// exports
